import { CacheStrategy, PersistRules } from '../../../DataBase/rtk-persist/types'

import Consts from 'Utils/Consts'

const EXPIRE_TIME = Consts.env.REACT_APP_COMMON_CACHE_EXPIRE_TIME_IN_SECONDS * 1000

export const COMMON_DB_STORE = 'common-db'
export const COMMON_CACHE_STORE = 'queries'
export const COMMON_CACHE_VERSION = 1

export const persistRules: PersistRules = {
  getInsuranceExpertFieldsCurrentUser: {
    ttl: EXPIRE_TIME,
    strategy: CacheStrategy.CacheFirst,
  },

  getAllAccessList: {
    ttl: EXPIRE_TIME,
    strategy: CacheStrategy.CacheFirst,
  },

  getUserProfile: {
    ttl: EXPIRE_TIME,
    strategy: CacheStrategy.CacheFirst,
  },

  generateAllAudios: {
    ttl: EXPIRE_TIME,
    strategy: CacheStrategy.CacheFirst,
  },
}
